module.exports = __webpack_public_path__ + "img/Movie_poster.73368539.jpg";